export function swapPlayerPositions(teams, sourceId, targetId) {
  const players = [...teams.team1, ...teams.team2];
  if (teams.team1.length > 2 || teams.team2.length > 2 || players.length < 2 || new Set(players.map(p => Number(p.user_id))).size !== players.length) {
    throw new Error('ต้องมีผู้เล่นอย่างน้อย 2 คนและรายชื่อไม่ซ้ำกัน');
  }
  const from = players.findIndex(p => Number(p.user_id) === Number(sourceId));
  const to = players.findIndex(p => Number(p.user_id) === Number(targetId));
  if (from < 0 || to < 0) throw new Error('รายชื่อผู้เล่นเปลี่ยนแล้ว กรุณาลากใหม่');
  if (from === to) return null;
  [players[from], players[to]] = [players[to], players[from]];
  return { team1: players.slice(0, teams.team1.length), team2: players.slice(teams.team1.length) };
}
